import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_ALERTS_PENDING_PAYMENT_EDIT: MijnRoute = {
    path: 'ingepland-geweigerd-notificatie/:id',
    navigationEvent: 'toIngeplandGeweigerdNotificatie',
    regex: /^\/zelf-regelen\/notificaties-beheren\/ingepland-geweigerd-notificatie\/[^/]+$/,
    webcomponent: 'mijn-klant-notificatie-beheer-webcomponent',
    internalPath: '/ingepland-geweigerd-notificatie/:id'
};
